import { useCallback, useState } from 'react'
import { SortOptionsArray } from '../../../../api-client/enums/vehicle-sort-options'
import ListItemCheckbox from './list-item-checkbox'

export default function SortFilter({ onSortChange, handleFilterToggle }) {
  const [currentMake, setCurrentMake] = useState(null)

  const handleSortChange = useCallback(
    (make, checked) => {
      setCurrentMake(make)
      onSortChange(make, checked)
      setSelectedSort(make.label)
      handleFilterToggle('sort')
    },
    [onSortChange, handleFilterToggle],
  )

  const [selectedSort, setSelectedSort] = useState('')

  return (
    <div>
      {!currentMake && (
        <div className='wrapper'>
          <div className='sortView'>
            <ul className='sortList'>
              {SortOptionsArray.map((sort) => (
                <ListItemCheckbox
                  key={sort.id}
                  value={sort.value}
                  onChange={handleSortChange}
                  selectedSort={selectedSort}
                >
                  {sort.label}
                </ListItemCheckbox>
              ))}
            </ul>
          </div>
        </div>
      )}
      <style jsx>{`
        .wrapper {
          min-height: 29.8rem;
          width: 25rem;
          padding: 2rem;
          border-radius: 1rem;
          background: #fff;
          box-shadow: 0 0.3rem 0.6rem rgba(0, 0, 0, 0.16);
          color: var(--secondary-text-color);
        }

        .sortView {
          > label {
            display: block;
            margin: 0 0 1.1rem;
            font-size: 1.6rem;
            font-weight: 700;
          }

          .sortList {
            margin: 3rem 0 0;
            height: 20.6rem;
            overflow: auto;

            :global(button:active) {
              outline: none;
            }
          }
        }

        .modelsView {
          .backBtn {
            font-size: 1.6rem;
            font-weight: 700;
          }

          .currentMakeName {
            margin: 1.8rem 0 0.4rem;
            text-align: center;
            color: var(--primary-text-color);
            font-size: 2.4rem;
            font-weight: 700;
          }

          .description {
            margin: 0 0 1.6rem;
            text-align: center;
            font-size: 1.6rem;
            font-weight: 700;

            button {
              margin: 0 0 0 0.5rem;
              color: var(--text-link-color);
              font: inherit;
            }
          }

          .modelsContainer {
            height: 26.5rem;
            overflow: auto;
          }

          .modelsList {
            width: 100%;

            :global(li) {
              max-width: 18.8rem;
              width: 100%;
            }
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            width: 100%;
            padding: 3rem;
            box-shadow: none;
            border-radius: 0;
          }

          .sortList {
            height: 100% !important;
          }

          .sortView {
            > label {
              font-size: 1.2rem;
            }
          }

          .modelsView {
            display: block;

            .modelsContainer {
              height: 100%;
            }

            .backBtn {
              font-size: 1.2rem;
            }

            .currentMakeName {
              font-size: 1.8rem;
            }

            .description {
              font-size: 1.4rem;
            }

            .modelsList {
              :global(li) {
                max-width: 100%;
              }
            }
          }
        }
      `}</style>
    </div>
  )
}
